var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTshirtLens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.4 113.4",
    style: {
      enableBackground: "new 0 0 113.4 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#717070;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.1,105.2L94.8,90.9v0c6.4-8.3,6.4-19.8,0-28.1c-2.8-3.7-6.6-6.2-10.7-7.6V38l12.5,2.6 c1.5,0.3,2.9-0.6,3.2-2.1l4.2-19.2c0.3-1.3-0.4-2.6-1.7-3.1L70.1,3.6c-0.5-0.2-1.1-0.3-1.5-0.1c-4.9,0.8-9.9,1.3-14.8,1.3 c0,0-0.1,0-0.1,0c-4.9,0-9.9-0.4-14.6-1.3c-0.2,0-0.4-0.1-0.6-0.1c-0.4,0-0.8,0.1-1.1,0.2L5.2,16.3c-1.3,0.5-2,1.9-1.7,3.1l4.2,19.1 C8.1,40,9.5,41,11,40.7L23.5,38v44.2c0,1.5,1.2,2.7,2.7,2.7h29.1c0.8,2.1,1.9,4.1,3.3,6c7.8,10,22.2,11.8,32.2,4.1l14.3,14.3 c1.1,1,2.8,1,3.9,0C110.1,108.2,110.2,106.4,109.1,105.2z M53.6,10.1c4.1,0,8.3-0.3,12.4-0.8c-0.6,2.1-1.7,4.1-3.3,5.6l0,0 c-4.9,4.9-12.9,4.9-17.9,0c-1.6-1.5-2.7-3.5-3.3-5.6C45.6,9.8,49.6,10.1,53.6,10.1z M53.9,79.5H28.9V34.7c0-0.2,0-0.3-0.1-0.6 c-0.3-1.5-1.8-2.4-3.2-2.1l-13.2,2.7L9.4,20.5L36.2,9.9c0.7,3.3,2.5,6.4,4.9,8.8c2.7,2.7,6.3,4.5,10,5.1v9.9c0,0.7,0.3,1.4,0.8,1.9 c0.5,0.5,1.2,0.8,1.9,0.8c0,0,0,0,0,0c0.7,0,1.4-0.3,1.9-0.8c0.5-0.5,0.8-1.2,0.8-1.9v-9.9c3.8-0.6,7.3-2.4,10-5.1 c2.4-2.4,4.2-5.5,4.9-8.9l26.8,10.6l-3.1,14.3l-13-2.7C81.9,32,81.7,32,81.4,32c0,0,0,0,0,0c-0.7,0-1.4,0.3-1.9,0.8 c-0.5,0.5-0.8,1.2-0.8,1.9V54c-5.6-0.5-11.3,1-16.1,4.7C56.1,63.8,53,71.8,53.9,79.5z M88.8,89c-6.7,6.7-17.6,6.7-24.3,0 c0,0,0,0,0,0c-6.7-6.7-6.7-17.6,0-24.3c6.7-6.7,17.6-6.7,24.3,0C95.6,71.4,95.6,82.3,88.8,89z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshirtLens);
export default __webpack_public_path__ + "static/media/tshirt_lens.d763ed937bad59f0fc1736695ec80f4b.svg";
export { ForwardRef as ReactComponent };